import { createAction, handleActions } from 'redux-actions';
import { Api } from '../../api/api';
import { logout, onForbidden } from '../account/login';
import { fetchSubmitFormSuccess, fetchSubmitFormFailed, fetchSubmitForm } from '../common/submitForm';
import _ from 'lodash';
import { getCurrentGroup } from '../account/role';
import { hideModal } from '../common/activeModal';
import moment from 'moment';

const CONSENT_REQUESTS_PAGE_SIZE = 10;

export const CONSENT_REQUESTS_FILTER = {
    ALL: "ALL",
    PENDING: "PENDING",
    GRANTED: "GRANTED",
    REJECTED: "REJECTED",
    REVOKED: "REVOKED",
    EXPIRED: "EXPIRED"
};

export const CONSENT_REQUESTS_CANCELED = "ABANDONED";

//- Actions
export const fetchGetOrganizationConsentsFailed = createAction('FETCH_GET_ORGANIZATION_CONSENTS_FAILED');
export const onGetOrganizationConsentsSuccess = createAction('FETCH_GET_ORGANIZATION_CONSENTS_SUCCESS');
export const fetchGetOrganizationConsentsSuccess = (data) => (dispatch) => {
    if (data.length < CONSENT_REQUESTS_PAGE_SIZE) {
        dispatch(onGetOrganizationConsentsSuccess(data));
        dispatch(setNextPageAvailable(false));        
    } else {
        dispatch(onGetOrganizationConsentsSuccess(data));
        dispatch(setUpdatedBefore(_.last(data).updatedAt));
        dispatch(setNextPageAvailable(true));  
    }
};
export const fetchGetOrganizationConsents = () => (dispatch, getState) => {
    let status = getCurrentConsentRequestsFilterStatus(getState());
    let job = getCurrentConsentRequestsFilterJob(getState());
    let departmentId = getCurrentGroup(getState());
    if (departmentId) {
        let filterParams = {
            updatedBefore: moment().utc().format(),
            status: status !== CONSENT_REQUESTS_FILTER.ALL ? status : null,
            job: job
        };
        dispatch(onGetOrganizationConsents(departmentId, filterParams));
    }
};
export const onGetOrganizationConsents = createAction(
    'FETCH_GET_ORGANIZATION_CONSENTS',
    (departmentId, filterParams) => Api.getOrganizationConsents(departmentId, filterParams),
    () => ({
        apiCall: true,
        onSuccess: fetchGetOrganizationConsentsSuccess,
        onFail: fetchGetOrganizationConsentsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const fetchGetOrganizationConsentsNextPageFailed = createAction('FETCH_GET_ORGANIZATION_CONSENTS_NEXT_PAGE_FAILED');
export const onGetOrganizationConsentsNextPageSuccess = createAction('FETCH_GET_ORGANIZATION_CONSENTS_NEXT_PAGE_SUCCESS');
export const fetchGetOrganizationConsentsNextPageSuccess = (data) => (dispatch) => {
    if (data.length < CONSENT_REQUESTS_PAGE_SIZE) {
        dispatch(onGetOrganizationConsentsNextPageSuccess(data));
        dispatch(setNextPageAvailable(false));        
    } else {
        dispatch(onGetOrganizationConsentsNextPageSuccess(data));
        dispatch(setUpdatedBefore(_.last(data).updatedAt));
    }
};
export const fetchGetOrganizationConsentsNextPage = () => (dispatch, getState) => {
    let status = getCurrentConsentRequestsFilterStatus(getState());
    let job = getCurrentConsentRequestsFilterJob(getState());
    let departmentId = getCurrentGroup(getState());
    if (departmentId && isLoadNextPageAvailable(getState())) {
        let filterParams = {
            updatedBefore: getUpdatedBefore(getState()),
            status: status !== CONSENT_REQUESTS_FILTER.ALL ? status : null,
            job: job
        };
        dispatch(onGetOrganizationConsentsNextPage(departmentId, filterParams));
    }
};
export const onGetOrganizationConsentsNextPage = createAction(
    'FETCH_GET_ORGANIZATION_CONSENTS_NEXT_PAGE',
    (departmentId, filterParams) => Api.getOrganizationConsents(departmentId, filterParams),
    () => ({
        apiCall: true,
        onSuccess: fetchGetOrganizationConsentsNextPageSuccess,
        onFail: fetchGetOrganizationConsentsNextPageFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const setUpdatedBefore = createAction('SET_UPDATED_BEFORE');
export const setNextPageAvailable = createAction('SET_NEXT_PAGE_AVAILABLE');

export const setCurrentConsentRequestsFilterStatus = (newStatus) => (dispatch) => {
    dispatch(onSetCurrentConsentRequestsFilterStatus(newStatus));
    dispatch(fetchGetOrganizationConsents());
};
export const onSetCurrentConsentRequestsFilterStatus = createAction('SET_CURRENT_CONSENT_REQUEST_FILTER_STATUS');

export const setCurrentConsentRequestsFilterJob = (newJob) => (dispatch) => {
    dispatch(onSetCurrentConsentRequestsFilterJob(newJob));
    dispatch(fetchGetOrganizationConsents());
};
export const onSetCurrentConsentRequestsFilterJob = createAction('SET_CURRENT_CONSENT_REQUEST_FILTER_JOB');

export const setCurrentConsentRequest = (id) => (dispatch) => {
    dispatch(fetchGetConsentRequestDetails(id));
    dispatch(onSetCurrentConsentRequest(id));
};
export const onSetCurrentConsentRequest = createAction('SET_CURRENT_CONSENT_REQUEST');

export const fetchGetConsentRequestDetailsFailed = createAction('FETCH_GET_CONSENT_REQUEST_DETAILS_FAILED');
export const fetchGetConsentRequestDetailsSuccess = createAction('FETCH_GET_CONSENT_REQUEST_DETAILS_SUCCESS');
export const onGetConsentRequestDetailsSuccess = (data) => (dispatch, getState) => {
    let listData = _.cloneDeep(getOrganizationConsentsData(getState()));
    let id = getCurrentConsentRequestId(getState());
    let index = _.findIndex(listData, ((elem) => elem.id === id));
    listData[index].status = data.status;
    listData[index].updatedAt = data.updatedAt;
    if (!_.isNil(data.grantedTill)) {
        listData[index].grantedTill = data.grantedTill;
    }
    dispatch(updateOrganizationConsentsData(listData));
    dispatch(fetchGetConsentRequestDetailsSuccess(data));
};
export const fetchGetConsentRequestDetails = createAction(
    'FETCH_GET_CONSENT_REQUEST_DETAILS',
    (id) => Api.getConsentRequestDetails(id),
    () => ({
        apiCall: true,
        onSuccess: onGetConsentRequestDetailsSuccess,
        onFail: fetchGetConsentRequestDetailsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const updateOrganizationConsentsData = createAction('UPDATE_ORGANIZATION_CONSENTS_DATA');
export const clearCurrentConsentRequestData = createAction('CLEAR_CURRENT_CONSENT_REQUEST_DATA');

export const fetchAbandonConsentRequestSuccess = (id) => () => (dispatch, getState) => {
    dispatch(fetchSubmitFormSuccess());
    let listData = _.cloneDeep(getOrganizationConsentsData(getState()));
    _.remove(listData, (elem) => elem.id === id);
    dispatch(updateOrganizationConsentsData(listData));
    dispatch(clearCurrentConsentRequestData());
    dispatch(hideModal());
};
export const fetchAbandonConsentRequest = (id) => (dispatch) => {
    dispatch(fetchSubmitForm());
    dispatch(onFetchAbandonConsentRequest(id));
};
export const onFetchAbandonConsentRequest = createAction(
    'FETCH_CANCEL_CONSENT_REQUEST',
    (id) => Api.abandonConsentRequest(id),
    (id) => ({
        apiCall: true,
        onSuccess: fetchAbandonConsentRequestSuccess(id),
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

//- State
const initialState = {
    data: null,
    updatedBefore: null,
    isNextPageAvailable: true,
    currentConsentRequestId: null,
    currentConsentRequestData: null,
    currentFilterStatus: CONSENT_REQUESTS_FILTER.ALL,
    currentFilterJob: "",
    error: null,
    fetching: false,
    fetchingCurrentConsentRequest: false
};

//- Reducers
export default handleActions({

    FETCH_GET_ORGANIZATION_CONSENTS: (state) => {
        return { ...state, data: null, currentPage: null, totalPages: null, currentConsentRequestId: null, currentConsentRequestData: null, error: null, fetching: true };
    },
    FETCH_GET_ORGANIZATION_CONSENTS_FAILED: (state, action) => {
        return { ...state, data: null, currentPage: null, totalPages: null, error: action.payload, fetching: false };
    },
    FETCH_GET_ORGANIZATION_CONSENTS_SUCCESS: (state, action) => {
        return { ...state, data: action.payload, error: null, fetching: false };
    },
    FETCH_GET_ORGANIZATION_CONSENTS_NEXT_PAGE: (state) => {
        return { ...state, error: null, fetching: true };
    },
    FETCH_GET_ORGANIZATION_CONSENTS_NEXT_PAGE_FAILED: (state, action) => {
        return { ...state, error: action.payload, fetching: false };
    },
    FETCH_GET_ORGANIZATION_CONSENTS_NEXT_PAGE_SUCCESS: (state, action) => {
        return { ...state, data: [...state.data, ...action.payload], error: null, fetching: false };
    },
    SET_UPDATED_BEFORE: (state, action) => {
        return { ...state, updatedBefore: action.payload };
    },
    SET_NEXT_PAGE_AVAILABLE: (state, action) => {
        return { ...state, isNextPageAvailable: action.payload };
    },
    UPDATE_ORGANIZATION_CONSENTS_DATA: (state, action) => {
        return { ...state, data: action.payload };
    },
    FETCH_GET_CONSENT_REQUEST_DETAILS: (state) => {
        return { ...state, currentConsentRequestData: null, error: null, fetchingCurrentConsentRequest: true };
    },
    FETCH_GET_CONSENT_REQUEST_DETAILS_FAILED: (state, action) => {
        return { ...state, currentConsentRequestData: null, error: action.payload, fetchingCurrentConsentRequest: false };
    },
    FETCH_GET_CONSENT_REQUEST_DETAILS_SUCCESS: (state, action) => {
        return { ...state, currentConsentRequestData: action.payload, error: null, fetchingCurrentConsentRequest: false };
    },
    CLEAR_CURRENT_CONSENT_REQUEST_DATA: (state) => {
        return { ...state, currentConsentRequestData: null, currentConsentRequestId: null };
    },
    SET_CURRENT_CONSENT_REQUEST_FILTER_STATUS: (state, action) => {
        return { ...state, currentFilterStatus: action.payload };
    },
    SET_CURRENT_CONSENT_REQUEST_FILTER_JOB: (state, action) => {
        return { ...state, currentFilterJob: action.payload };
    },
    SET_CURRENT_CONSENT_REQUEST: (state, action) => {
        return { ...state, currentConsentRequestId: action.payload };
    }

}, initialState);

//- Selectors
export const getOrganizationConsents = state => state.organizationConsents;

export const loadingOrganizationConsents = state => getOrganizationConsents(state).fetching;

export const loadingCurrentConsentRequest = state => getOrganizationConsents(state).fetchingCurrentConsentRequest;

export const getCurrentConsentRequestId = state => getOrganizationConsents(state).currentConsentRequestId;

export const getCurrentConsentRequestData = state => getOrganizationConsents(state).currentConsentRequestData;

export const getCurrentConsentRequestsFilterStatus = state => getOrganizationConsents(state).currentFilterStatus;

export const getCurrentConsentRequestsFilterJob = state => getOrganizationConsents(state).currentFilterJob;

export const getOrganizationConsentsData = state => getOrganizationConsents(state).data;

export const isLoadNextPageAvailable = state => getOrganizationConsents(state).isNextPageAvailable;

export const getUpdatedBefore = state => getOrganizationConsents(state).updatedBefore;


// WEBPACK FOOTER //
// ./src/reducers/consent/organizationConsents.js